import { render, staticRenderFns } from "./OrderStatusesView.vue?vue&type=template&id=33c512f0&scoped=true&"
import script from "./OrderStatusesView.vue?vue&type=script&lang=js&"
export * from "./OrderStatusesView.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusesView.vue?vue&type=style&index=0&id=33c512f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c512f0",
  null
  
)

export default component.exports